import React, { useEffect } from 'react';
import { Box, Typography, Slide } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

const CustomToast = ({ open, message, severity = 'success', onClose }) => {
  useEffect(() => {
    if (open && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  const getIcon = () => {
    switch (severity) {
      case 'success':
        return <CheckCircleIcon sx={{ fontSize: 20, color: '#fff' }} />;
      case 'error':
        return <ErrorIcon sx={{ fontSize: 20, color: '#fff' }} />;
      case 'info':
        return <InfoIcon sx={{ fontSize: 20, color: '#fff' }} />;
      default:
        return <CheckCircleIcon sx={{ fontSize: 20, color: '#fff' }} />;
    }
  };

  const getBackgroundColor = () => {
    switch (severity) {
      case 'success':
        return 'linear-gradient(135deg, #111111 0%, #1a1a1a 100%)';
      case 'error':
        return 'linear-gradient(135deg, #FF3B30 0%, #FF453A 100%)';
      case 'info':
        return 'linear-gradient(135deg, #111111 0%, #1a1a1a 100%)';
      default:
        return 'linear-gradient(135deg, #111111 0%, #1a1a1a 100%)';
    }
  };

  if (!open) return null;

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999,
          maxWidth: { xs: 'calc(100vw - 40px)', sm: '400px' },
          width: '100%',
          background: getBackgroundColor(),
          borderRadius: '16px',
          padding: '16px 20px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3), 0 8px 32px rgba(0, 0, 0, 0.2)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          animation: 'toastSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          '@keyframes toastSlideIn': {
            '0%': {
              opacity: 0,
              transform: 'translate(-50%, -50%) scale(0.9)',
            },
            '100%': {
              opacity: 1,
              transform: 'translate(-50%, -50%) scale(1)',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {getIcon()}
        </Box>
        <Typography
          sx={{
            color: '#fff',
            fontSize: '0.95rem',
            fontWeight: 600,
            fontFamily: 'NanumSquareB',
            lineHeight: 1.4,
            letterSpacing: '-0.01em',
            flex: 1,
            textAlign: 'left',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Slide>
  );
};

export default CustomToast; 